import moment from 'moment';
import tableClientHomepageTemplate from './tableClientHomepage.tpl.html';
import utils from '../../services/utils';
import getStoredLanguage from '../../utilities/language';

export class TableClientHomepage {
  constructor($scope, $ngRedux, actionsFactory, $translate, $state, ordersService) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      $state,
      ordersService,
      sort: {
        sortBy: 'updated_at',
        sortDir: 'desc',
      },
    });
    const unsubscribe = $ngRedux.connect(TableClientHomepage.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);

    this.scoreLegend = [
      {
        min: 0,
        max: 0,
        value: 'C',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_CRITICAL')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_CRITICAL')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_CRITICAL')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_CRITICAL')}`,
      },
      {
        min: 1,
        max: 25,
        value: 'CC',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_WEAK')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_WEAK')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_WEAK')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_WEAK')}`,
      },
      {
        min: 26,
        max: 40,
        value: 'CCC',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_WEAK')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_WEAK')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_WEAK')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_WEAK')}`,
      },
      {
        min: 41,
        max: 50,
        value: 'B',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_FAIR')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_FAIR')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR')}`,
      },
      {
        min: 51,
        max: 60,
        value: 'BB',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_FAIR')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_FAIR')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR')}`,
      },
      {
        min: 61,
        max: 70,
        value: 'BBB',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_FAIR')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_FAIR')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR')}`,
      },
      {
        min: 71,
        max: 80,
        value: 'A',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_GOOD')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_GOOD')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_GOOD')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_GOOD')}`,
      },
      {
        min: 81,
        max: 90,
        value: 'AA',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_GOOD')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_GOOD')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_GOOD')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_GOOD')}`,
      },
      {
        min: 91,
        max: 100,
        value: 'AAA',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_EXCELLENT')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_EXCELLENT')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_EXCELLENT')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_EXCELLENT')}`,
      },
    ];

    this.showModal = false;
    this.modalNotes = '';

    this.getIntValue = TableClientHomepage.getIntValue;
    this.getReputationScore = TableClientHomepage.getReputationScore;

    this.currentLang = null;
  }

  static mapStateToThis(state) {
    return {
      auth: state.authentication,
      summariesIds: state.summaries.ids,
      summariesById: state.summaries.byId,
      loading: state.summaries.loading,
      error: state.summaries.error,
      total: state.summaries.total,
    };
  }

  $onInit() {
    this.page = 1;
    this.limit = 5;
    this.companyName = '';
    this.sortSelect = `${this.sort.sortBy}|${this.sort.sortDir}`;
    this.getSummaries();
    this.currentLang = getStoredLanguage();
  }

  getSummaries() {
    if (utils.isLoggedInUserOfType(this.auth.user.type, [
      'buyer',
      'master',
      'director'])) {
      this.requestOrderedCompaniesOverviewStart({
        sort: { company_name: '' },
        search: { company_name: '' },
        sort_by: this.sort.sortBy,
        sort_dir: this.sort.sortDir,
        page: this.page,
        limit: this.limit,
      });
    }
  }

  requestOrderReport(orderId, locale) {
    this.requestOrderReportStart(orderId, locale);
  }

  sortSummaries() {
    const sortSelect = this.sortSelect.split('|');
    this.sort.sortBy = sortSelect[0];
    this.sort.sortDir = sortSelect[1];
    this.getSummaries();
  }

  searchSummaries() {
    this.page = 1;

    if (utils.isLoggedInUserOfType(this.auth.user.type, [
      'buyer',
      'master',
      'director'])) {
      this.requestOrderedCompaniesOverviewStart({
        sort: { company_name: '' },
        search: { company_name: this.companyName },
        sort_by: this.sort.sortBy,
        sort_dir: this.sort.sortDir,
        page: this.page,
        limit: this.limit,
      });
    }
  }

  nextPage() {
    this.page += 1;
    this.getSummaries();
  }

  prevPage() {
    this.page -= 1;
    this.getSummaries();
  }

  static getIntValue(value) {
    if (value === null || value === undefined) {
      return '-';
    }

    return (value > 0) ? 'C' : 'A';
  }

  static getReputationScore(order, type) {
    const scoreValue = Math.round(order.avgScore);

    if (type === 'label') {
      return this.scoreLegend
        .find(el => scoreValue >= el.min && scoreValue <= el.max).label;
    } else if (type === 'value') {
      return this.scoreLegend
        .find(el => scoreValue >= el.min && scoreValue <= el.max).value;
    }

    return scoreValue;
  }

  getScoreValue(score) {
    if (score === null || score === undefined || score < 0 || score > 100) {
      return '-';
    }
    return this.scoreLegend
      .find(el => Math.round(score) >= el.min && Math.round(score) <= el.max).value;
  }

  getScoreLabel(score) {
    if (score === null || score === undefined || score < 0 || score > 100) {
      return '-';
    }
    return this.scoreLegend
      .find(el => Math.round(score) >= el.min && Math.round(score) <= el.max).label;
  }

  getScoreLegend(score) {
    const legendTitle = this.$translate.instant('SCORE_LEGEND_TITLE');

    const tiles = this.scoreLegend
      .map((el) => {
        const active = Math.round(score) >= el.min && Math.round(score) <= el.max ? 'active' : '';
        return `<div class="tile ${active}"><span class="tile__score">${el.value}</span><span class="tct-score-brick tile__brick tct-score-brick--${el.value}"></span></div>`;
      })
      .join('');

    const legend = `<h2>${legendTitle}</h2><div class="tiles">${tiles}</div>`;
    return legend;
  }

  getAllScoreDescriptions(scoreLabel) {
    const legendBase = this.$translate.instant('PRODUCT_DESCRIPTION_BASE');
    const legendTop = this.$translate.instant('PRODUCT_DESCRIPTION_TOP');
    const legendPremium = this.$translate.instant('PRODUCT_DESCRIPTION_PREMIUM');

    const content = this.scoreLegend
      .map((el) => {
        if (el.value !== scoreLabel) {
          return '';
        }
        return `<h2>${legendBase}</h2><div class="score-description">${el.descriptionBase}</div>
        <h2>${legendTop}</h2><div class="score-description">${el.descriptionTop}</div>
        <h2>${legendPremium}</h2><div class="score-description">${el.descriptionPremium}</div>`;
      })
      .join('');

    return content;
  }

  showNotesModal(notes) {
    this.modalNotes = notes;
    this.showModal = true;
  }

  closeNotesModal() {
    this.showModal = false;
    this.modalNotes = '';
  }

  /* eslint-disable */
  formatDate(date) {
    return `${moment(date).format('DD-MM-YYYY').replace(/-/g, '.')} ${moment(date).format('HH:mm')}`;
  }
  /* eslint-disable */
}

TableClientHomepage.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
  '$state',
  'ordersService',
];

export const tctTableClientHomepage = {
  template: tableClientHomepageTemplate,
  controller: TableClientHomepage,
};
